












































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CollapsableItem } from '../../../models/CollapsableMenu';

@Component
export default class ContactsSection extends Vue {
    @Prop() private item!: CollapsableItem;
}
